module.exports = __webpack_public_path__ + "img/whackamole.18ba40c7.png";